import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import './TransactionByGroup.scss';

interface TransactionByGroupProps {
  groups: {
    groupId: number,
    groupName: string
    typeId: number,
    description: string,
    taCount: number
    amount: number
  }[]
}

function TransactionByGroup({ groups }: TransactionByGroupProps) {
  const { t } = useTranslation();

  return (
    <div className="transaction-group">
      <div className="transaction-group__header">
        <span>{ t('transactions.groupId') }</span>
        <span>{ t('transactions.groupName') }</span>
        <span>{ t('transactions.taCount') }</span>
        <span>{ t('transactions.amount') }</span>
      </div>
      <div className="transaction-group__body">
        {
          groups &&
          _.map(groups, (group) => {
            return (
              <div className="transaction-group__item" key={ group.groupId }>
                <span>{ group.groupId }</span>
                <span>{ group.groupName }</span>
                <span>{ ((+group.taCount)) }</span>
                <span>{  ((+group?.amount)).toFixed(2) || 0.00 }</span>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}

export default TransactionByGroup;
